import React from 'react';
import { useSelector } from "react-redux";
import { selectOneSetting } from "../../util/store/selectors";
import { CERTAIN_TYPE, certainType, OP_STATUS, statusHideCertain } from "../../util/varibles/constants";
import { TOperation } from "../../util/varibles/interface";
import { PreferenceSetting } from "../../util/varibles/userSetting";
import styles from "./style.module.scss";

interface IProps {
    visible?: boolean
    operation: TOperation
    status: OP_STATUS
    isLabel?: boolean
}

const Certain: React.FC<IProps> = (props) => {
    const isCertainty = useSelector(selectOneSetting(PreferenceSetting.SHOW_CERTAINTY));
    const { certain_mode = CERTAIN_TYPE.NONE } = props.operation;
    const { status, visible = true, isLabel = true } = props;

    if (!visible || !isCertainty || statusHideCertain.indexOf(status) !== -1)
        return null;

    const { icon, name, color, fontColor } = certainType[certain_mode] || {
        icon: null,
        name: '',
        color: '',
        fontColor: ''
    };
    const style: any = { '--color': fontColor, background: color }

    return <div
        ref={(node) => {
            node?.style.setProperty("color", fontColor, "important")
        }}
        className={styles.certain}
        data-icon={icon}
        data-is-label={isLabel}
        title={name}
        style={style}
    >
        {isLabel ? name : ""}
    </div>
};

export default Certain;